import { render, staticRenderFns } from "./AbkObservedSearchResults.vue?vue&type=template&id=187d113a&scoped=true&"
import script from "./AbkObservedSearchResults.vue?vue&type=script&lang=js&"
export * from "./AbkObservedSearchResults.vue?vue&type=script&lang=js&"
import style0 from "./AbkObservedSearchResults.vue?vue&type=style&index=0&id=187d113a&scoped=true&lang=scss&"
import style1 from "./AbkObservedSearchResults.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187d113a",
  null
  
)

export default component.exports